import SEO from '../../seo/SEO'
import './Terminos.css'

const Terminos = () => {
  return (
    <>
      <SEO 
        title="Términos y Condiciones"
        description="Términos y condiciones de uso del sitio web del Estudio Contable Vanesa Mondejar. Conocé las reglas de utilización de nuestro sitio."
        canonical="https://vanesamondejar.com/terminos"
        keywords="términos y condiciones, estudio contable, uso del sitio web"
      />
      
      <main className="legal-page">
        <section className="legal-hero">
          <div className="container">
            <h1 className="legal-hero__title">Términos y Condiciones</h1>
            <p className="legal-hero__updated">Última actualización: Febrero 2025</p>
          </div>
        </section>

        <section className="legal-content">
          <div className="container">
            <div className="legal-content__wrapper">
              <div className="legal-content__block">
                <h2>1. Objeto</h2>
                <p>
                  Las presentes condiciones generales regulan el acceso y uso del sitio web del Estudio Contable 
                  Vanesa Mondejar. La utilización del sitio implica la aceptación plena de estos términos por 
                  parte del usuario. Si no está de acuerdo con alguno de ellos, le rogamos que se abstenga de 
                  utilizar este sitio.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>2. Información del sitio</h2>
                <p>
                  El contenido de este sitio web tiene carácter meramente informativo y no constituye asesoramiento 
                  profesional. La información ofrecida es de carácter general y no sustituye una consulta 
                  personalizada. Para obtener asesoramiento contable, impositivo o legal específico, debe 
                  establecer una relación profesional formal con el estudio.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>3. Uso adecuado</h2>
                <p>
                  El usuario se compromete a utilizar el sitio web de forma lícita, respetando la normativa 
                  vigente y los derechos de terceros. Queda prohibido el uso del sitio para fines ilícitos o 
                  que puedan dañar, inutilizar o sobrecargar el mismo. Asimismo, no se permite la introducción 
                  de virus, malware o cualquier otro elemento que pueda alterar el funcionamiento del sitio.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>4. Propiedad intelectual</h2>
                <p>
                  Todos los contenidos del sitio web (textos, imágenes, logotipos, diseño, estructura y demás 
                  elementos) son propiedad del Estudio Contable Vanesa Mondejar o de sus licenciantes y están 
                  protegidos por la legislación aplicable en materia de propiedad intelectual. No está permitida 
                  su reproducción, distribución, modificación o uso comercial sin autorización expresa.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>5. Servicios profesionales</h2>
                <p>
                  Los servicios contables, impositivos y de asesoramiento que ofrecemos se regirán por los 
                  términos acordados expresamente con cada cliente en el correspondiente contrato o acuerdo 
                  de prestación de servicios. La relación profesional se formalizará por escrito y quedará 
                  sujeta a la normativa profesional aplicable.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>6. Enlaces</h2>
                <p>
                  Este sitio puede contener enlaces a sitios web de terceros. El estudio no asume 
                  responsabilidad alguna respecto al contenido, exactitud o funcionamiento de dichos sitios 
                  externos. La inclusión de enlaces no implica respaldo ni asociación con las páginas enlazadas.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>7. Limitación de responsabilidad</h2>
                <p>
                  El Estudio Contable Vanesa Mondejar se esfuerza por mantener la información del sitio 
                  actualizada y correcta, pero no garantiza la ausencia de errores u omisiones. El uso del 
                  sitio es bajo la responsabilidad exclusiva del usuario. No nos hacemos responsables de 
                  daños directos o indirectos que pudieran derivarse del acceso o uso de la información 
                  contenida en este sitio.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>8. Disponibilidad</h2>
                <p>
                  Nos reservamos el derecho de modificar, suspender o interrumpir, total o parcialmente, 
                  el sitio web o cualquiera de sus contenidos en cualquier momento, sin necesidad de 
                  previo aviso, sin que ello genere responsabilidad frente al usuario.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>9. Legislación aplicable</h2>
                <p>
                  Las presentes condiciones se rigen por la legislación de la República Argentina. Para 
                  cualquier controversia derivada del uso del sitio web, las partes se someten a los 
                  tribunales competentes del domicilio del estudio.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>10. Contacto</h2>
                <p>
                  Para cualquier consulta relacionada con estos términos y condiciones, podés contactarnos 
                  a través de los canales indicados en la sección de contacto de este sitio web.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default Terminos
